import { useCallback, useState } from "react"

import { downloadIntakeFormPdf, printIntakeFormPdf } from "../../utils/intakeFormPdf"

export function useIntakeFormPdfExport({ surveyJson, getSurveyJson, responseData, formName, licenseKey, onError }) {
  const [busyAction, setBusyAction] = useState(null)

  const handleError = useCallback(
    (error) => {
      if (onError) {
        onError(error)
        return
      }
      window.alert(error?.message || "Unable to export this form. Please try again.")
    },
    [onError]
  )

  const resolveSurveyJson = useCallback(() => {
    if (getSurveyJson) {
      const json = getSurveyJson()
      if (json) return json
    }
    return surveyJson
  }, [getSurveyJson, surveyJson])

  const runExport = useCallback(
    async (action) => {
      if (busyAction) return

      setBusyAction(action)
      try {
        const options = {
          surveyJson: resolveSurveyJson(),
          data: responseData,
          fileName: formName,
          licenseKey
        }

        if (action === "download") {
          await downloadIntakeFormPdf(options)
        } else {
          await printIntakeFormPdf(options)
        }
      } catch (error) {
        handleError(error)
      } finally {
        setBusyAction(null)
      }
    },
    [busyAction, formName, handleError, licenseKey, resolveSurveyJson, responseData]
  )

  return { busyAction, runExport }
}
